// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about{padding:16px;margin-top:40px!important}.about__title{font-size:1.5rem;color:#242424;margin:20px 0}.about__title .text-green{color:#198754}.about__description{color:#444;font-size:1rem}.about picture>img,.about picture source{margin-top:30px;border-radius:5px;width:100%;height:160px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
